export const CLAIMS_WIDGET_ID = 'axitech-claims-widget';

export const STEP_KEYS = {
  accidentSelector: 'accident-selector',
  repairForm: 'repair-form',
  retailerRepairForm: 'retailer-repair-form',
  repairReferralForm: 'repair-referral-form',
  singleVehicleForm: 'single-vehicle-form',
  singleVehicleLightForm: 'single-vehicle-light-form',
  patchSingleVehicleForm: 'patch-single-vehicle-form',
  optionalSingleVehicleForm: 'optional-single-vehicle-form',
  optionalSingleVehiclePersonalForm: 'optional-single-vehicle-personal-form',
  repairFinderForm: 'repair-finder-form',
  repairFinderFormUs: 'repair-finder-form-us',
  accidentReferralForm: 'accident-referral-form',
  boschReferralForm: 'bosch-referral-form',
  jlrReferralForm: 'jlr-referral-form',
  jlrReferralFormV2: 'jlr-referral-form-v2',
  suzukiReferralForm: 'suzuki-referral-form',
  jlrReferralFormV3: 'jlr-referral-form-v3',
  retailerReferralForm: 'retailer-referral-form',
  retailerDetailedReferralForm: 'retailer-detailed-referral-form',
  multipleVehicleForm: 'multiple-vehicle-form',
  windscreenForm: 'windscreen-form',
  theftClaimSelector: 'theft-claim-selector',
  vehicleTheftForm: 'vehicle-theft-form',
  theftFromVehicleForm: 'theft-from-vehicle-form',
  otherClaimSelector: 'other-claim-selector',
  maliciousDamageForm: 'malicious-damage-form',
  fireDamageForm: 'fire-damage-form',
  weatherDamageSelector: 'weather-damage-selector',
  floodForm: 'flood-form',
  hailLightningForm: 'hail-lightning-form',
  otherWeatherDamageForm: 'other-weather-damage-form',
  lockedOutForm: 'locked-out-form',
} as const;

export const WIDGET_TYPES = {
  claim: 'claim',
} as const;
